import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _ListLessonPlans = async (serachData = false) => {
  let url = ServiceUrl.LESSON_PLANS.LIST_LESSON_PLANS;
  return callApi(url, "post", serachData && serachData);
};

export const _ListStudents = async (serachData = false) => {
  let url = ServiceUrl.STUDENTS.LIST_STUDENTS;
  if (serachData) url += "?" + jsonToQuery(serachData);
  return callApi(url);
};

export const _UpcomingDayOrder = async (serachData = false) => {
  let url = ServiceUrl.MOB.UPCOMING_DAY_ORDER;
  if (serachData) url += "?" + jsonToQuery(serachData);
  return callApi(url);
};

export const _CheckAttEntered = async (serachData = false) => {
  let url = ServiceUrl.MOB.CHECK_ATT_ENTERED;
  return callApi(url, "post", serachData && serachData);
};
